import { useEffect, useState } from "react";
import { fetchSubscriptions } from "../../api/subscriptionApi";
import { useTranslation } from "react-i18next";
import SubscriptionCard from "./SubscriptionCard";
import SubscriptionCardView from "./SubscriptionCardView";
import i18next from "i18next";

const SubscriptionList = ({ ChooseSubsciption }) => {
  const [subscriptions, setSubscriptiones] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    async function getsubscriptions() {
      const data = await fetchSubscriptions({}); // Fetch subscription list
      setSubscriptiones(data);
    }
    getsubscriptions();
  }, []);
  const handlehooseSubsciption = (data) => {
 
    ChooseSubsciption(data);
  };

  return subscriptions.length ? (
    <>
      <div dir={i18next.language === "ar" ? "rtl" : "ltr"} className="container  px-4 py-12 w-full">
        <h1 className="text-5xl font-extrabold text-gray-900 text-center mb-6">
          {t("subcriptions_title")}
        </h1>
        <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto">
          {t("subscribemsg")}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-8">
     
          {subscriptions.map((sub, index) => (
            <SubscriptionCard
              key={sub.subscription_id}
              subscription={sub}
              onSelect={handlehooseSubsciption}
              onDelete={() => {}}
              showDelete={false}
              // Example: Make the second plan featured (adjust as needed for your data)
              isFeatured={index === 1}
            />
          ))}
        </div>
      </div>
    </>
  ) : (
    <p>{t("loadingsub")} </p>
  );
};

export default SubscriptionList;
